export const songs = [
  {
    artist: "Taylor Swift",
    name: "Anti-Hero",
    youtubeId: "b1kbLwvqugk",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Blank Space",
    youtubeId: "e-ORhEE9VVg",
    startSeconds: 4,
  },
  {
    artist: "Taylor Swift",
    name: "Shake It Off",
    youtubeId: "nfWlot6h_JM",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Love Story",
    youtubeId: "8xg3vE8Ie_E",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "You Belong With Me",
    youtubeId: "VuNIsY6JdUw",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "We Are Never Ever Getting Back Together",
    youtubeId: "WA4iX5D9Z64",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "I Knew You Were Trouble",
    youtubeId: "vNoKguSdy4Y",
    startSeconds: 113,
  },
  {
    artist: "Taylor Swift",
    name: "22",
    youtubeId: "AgFeZr5ptV8",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Style",
    youtubeId: "-CmadmM5cOk",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Wildest Dreams",
    youtubeId: "IdneKLhsWOQ",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift feat. Kendrick Lamar",
    name: "Bad Blood",
    youtubeId: "QcIy9NiNbmo",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Look What You Made Me Do",
    youtubeId: "3tmd-ClpJxA",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Delicate",
    youtubeId: "tCXGJQYZ9JA",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Lover",
    youtubeId: "-BjZmE2gtdo",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "cardigan",
    youtubeId: "K-a8s8OLBSE",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "willow",
    youtubeId: "RsEZmictANA",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Mean",
    youtubeId: "jYa1eI1hpDE",
    startSeconds: 0,
  },
  {
    artist: "Taylor Swift",
    name: "Mine",
    youtubeId: "XPBwXKgDTdE",
    startSeconds: 0,
  },
];
